<template>
  <div id="MenuButton">
    <v-menu
      bottom
      left
      :close-on-content-click="true"
      :nudge-width="200"
      offset-y
      rounded
      class="elevation-6"
      min-width="260"
      max-width="calc(100vw - 24px)"
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip
          dense
          bottom
        >
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              v-bind="attrs"
              icon
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <span>Menu</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img
              v-if="avatar"
              :src="avatar"
              :alt="'Photo of ' + userName"
            >
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ userName }}</v-list-item-title>
            <v-list-item-subtitle>User </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/dashboard">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/profile">
          <v-list-item-action>
            <v-icon>mdi-chart-box-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title>My profile</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="role.isAdmin" to="/admin/cluster">
          <v-list-item-action>
            <v-icon>mdi-server-network</v-icon>
          </v-list-item-action>
          <v-list-item-title>Cluster admin</v-list-item-title>
        </v-list-item>
        <v-list-item to="/examples">
          <v-list-item-action>
            <v-icon>mdi-flask-outline</v-icon>
          </v-list-item-action>
          <v-list-item-title>Examples</v-list-item-title>
        </v-list-item>
        <v-list-item to="/materials">
          <v-list-item-action>
            <v-icon>mdi-folder</v-icon>
          </v-list-item-action>
          <v-list-item-title>Materials</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          @click="dialogSettings = true"
        >
          <v-list-item-action>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialogLogout = true">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="dialogLogout"
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h6">
          Log out?
        </v-card-title>
        <v-card-text>
          Your simulations stay saved. You can sign in again with the same account.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogLogout = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="logout"
          >
            Log out
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSettings"
      max-width="500"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title>
          Settings <v-spacer />
          <v-btn
            icon
            @click="dialogSettings = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text><Settings /></v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import firebase from "firebase/app";
import { role, loadRole } from "@/common/role";
export default {
  name: "MenuButton",
  components: {
    Settings: () => import("@/pages/Settings"),
  },
  data: () => ({
    userName: "",
    avatar: "",
    dialogLogout: false,
    dialogSettings: false,
  }),
  computed: {
    role: () => role
  },
  mounted: function () {
    this.getUserData();
    loadRole();
  },
  methods: {
    logout: function () {
      const self = this;
      firebase
        .auth()
        .signOut()
        .then(() => {
          self.$router.push("/");
        });
    },
    getUserData: function () {
      // Contas de e-mail e senha não têm displayName nem foto
      const user = firebase.auth().currentUser;
      if (!user) return;
      const name = (user.displayName || user.email || "User").split(" ");
      this.userName = name.length > 1 ? name[0] + " " + name[name.length - 1] : name[0];
      this.avatar = user.photoURL || "";
    },
  },
};
</script>